export function noUndefinedsOrEmptyStrings(obj: Record<string, any>) {
    // traverse plain keys:
    for (const k of Object.keys(obj)) {
        // delete undefined values
        if (obj[k] === undefined) delete obj[k];
        if (obj[k] === "") delete obj[k];
    }
    // return same obj.
    return obj;
}